import { bool, string } from "prop-types";

import FnrSlides from "UI/FnrSlides";

import ActiveState from "./ActiveState";
import InactiveState from "./InactiveState";
import contentKeys from "./contentKeys";
import { useActiveContentKey } from "./stateHooks";

const buttonDisplayConfig = [
  { value: InactiveState, key: contentKeys.inactive },
  { value: ActiveState, key: contentKeys.active },
];

const ButtonDisplay = ({ color }) => {
  const contentKey = useActiveContentKey();
  return (
    <FnrSlides
      sizeSpring={contentKey !== contentKeys.inactive}
      activeKey={contentKey}
      color={color}
      components={buttonDisplayConfig}
      variant="subtle"
    />
  );
};

ButtonDisplay.propTypes = { color: string, isLoading: bool };

export default ButtonDisplay;
